import React, { useState } from "react";
import useFetchPost from "../hooks/useFetchPost";
import SelectPicker from "rsuite/SelectPicker";
import DatePicker from "rsuite/DatePicker";
import moment from "moment";
import { toast, Bounce } from "react-toastify";
const statusData = ["Credit Card", "Wire Transfer"].map((item) => ({ label: item, value: item }));
const MarkAsPaid = ({ data, setApiRun }) => {
	const [paymentMode, setPaymentMode] = useState("");
	const [description, setDescription] = useState("");
	const [paymentDate, setPaymentDate] = useState("");
	const [errors, setErrors] = useState({});

	const { fetchPostData, error } = useFetchPost();

	const handleClose = () => {
		const markAsPaid = document.getElementById("markAsPaid");
		markAsPaid.classList.remove("show");
		markAsPaid.style.display = "none";
		setPaymentMode("");
		setDescription("");
		setPaymentDate(null);
		setErrors({});
	};

	//form validation with data set

	const handleChangeDate = (value) => {
		if (!value) {
			setPaymentDate(null);
		} else {
			const formattedDates = moment(value).format("YYYY-MM-DD");
			setPaymentDate(value);
		}
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		const errors = validateForm();
		if (Object.keys(errors).length === 0) {
			// Submit form data
			const postData = {
				product_key: data && data.product_key,
				user_uuid: data && data.customer_user_uuid,
				milestone_uuid: data && data.milestone_uuid,
				milestone_payment_mode: paymentMode,
				milestone_receive: paymentDate,
				milestone_payment_note: description,
			};

			let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/mark-as-paid";
			let responseData;
			try {
				responseData = await fetchPostData(crmStagingUrl, postData);
				//console.log("Response:", responseData);
			} catch (error) {
				console.error("Error:", error);
			}
			if (responseData && responseData.code == 200) {
				setApiRun(true);
				// Reset form
				setPaymentMode("");
				setDescription("");
				setPaymentDate(null);
				setErrors({});
				toast.success(responseData.message, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
					transition: Bounce,
				});
			} else {
				const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";
				setPaymentMode("");
				setDescription("");
				setPaymentDate(null);
				setErrors({});
				toast.error(errorMessage, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
					transition: Bounce,
				});

				console.warn("Something went wrong .in change to mark as paid");
			}

			// Close the modal
			const markAsPaid = document.getElementById("markAsPaid");
			markAsPaid.classList.remove("show");
			markAsPaid.style.display = "none";
			// Close the modal
			document.getElementById("markAsPaid").dispatchEvent(new Event("click"));

			// Remove the backdrop
			document.getElementsByClassName("modal-backdrop")[0].remove();
		} else {
			setErrors(errors);
		}
	};
	const validateForm = () => {
		const errors = {};
		if (!paymentMode.trim()) {
			errors.paymentMode = "Mode of Payment is required";
		}
		if (!paymentDate) {
			errors.paymentDate = "Date of Payment is required";
		}
		if (!description.trim()) {
			errors.description = "Notes is required";
		}
		return errors;
	};

	return (
		<div className="modal fade" id="markAsPaid" tabindex="-1" role="dialog" aria-labelledby="markAsPaidLabel">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="markAsPaidLabel">
							Mark as Paid
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Mode of Payment
								</label>

								<SelectPicker
									data={statusData}
									name="milestone_payment_mode"
									value={paymentMode}
									onChange={setPaymentMode}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									searchable={false}
									placeholder="Select Mode of Payment"
								/>
								{errors.paymentMode && <span className="text-danger">{errors.paymentMode}</span>}
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Date of Payment
								</label>
								<DatePicker
									oneTap
									name="milestone_receive"
									block={true}
									value={paymentDate}
									onChange={handleChangeDate}
								/>
								{errors.paymentDate && <span className="text-danger">{errors.paymentDate}</span>}
							</div>

							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Notes
								</label>

								<textarea
									className="form-control"
									id="exampleFormControlTextarea1"
									rows="3"
									autoComplete="off"
									placeholder="Enter Note"
									name="milestone_payment_note"
									value={description}
									onChange={(e) => setDescription(e.target.value)}
								></textarea>
								{errors.description && <span className="text-danger">{errors.description}</span>}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<span
							type="button"
							className="btn btn-primary"
							// data-dismiss="modal"
							onClick={handleSubmit}
						>
							Submit
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MarkAsPaid;



// WEBPACK FOOTER //
// ./src/components/crm/modals/MarkAsPaid.jsx